import { render, staticRenderFns } from "./CategoriasSite.vue?vue&type=template&id=2cb3a81c"
import script from "./CategoriasSite.vue?vue&type=script&lang=js"
export * from "./CategoriasSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports